export default __webpack_public_path__ + "static/media/close.edb36b0b.svg";